import React, { useEffect, useState, useCallback } from "react";

import {
  Button,
  TextField,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { useForm, Controller } from "react-hook-form";

import { FormContainer, TextFieldElement, DateTimePickerElement } from "react-hook-form-mui";

import PropTypes from "prop-types";

function AddDialog({ open, worklogId, type, defaultValues, onClose, onSubmit }) {
  const { control, handleSubmit, reset } = useForm();

  const handleClose = () => {
    onClose && onClose();
  };

  useEffect(() => {
    // Set the default values when the component mounts
    reset(defaultValues);
  }, [defaultValues, reset]);

  const handleFormSubmit = (data) => {
    const { worklogStarted, timeSpentSeconds } = data;

    let updatedData = {};
    if (worklogStarted && worklogStarted !== defaultValues.worklogStarted) {
      updatedData["worklogStarted"] = new Date(worklogStarted).toISOString();
    }

    if (timeSpentSeconds && timeSpentSeconds !== defaultValues.timeSpentSeconds) {
      updatedData["timeSpentSeconds"] = parseInt(timeSpentSeconds);
    }

    onSubmit && onSubmit({ ...updatedData, worklogId, type });

    // reset();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <FormContainer
        control={control}
        defaultValue={defaultValues}
        onSuccess={handleSubmit(handleFormSubmit)}
      >
        <DialogTitle sx={{ pb: 0 }}>
          {type === "add" ? "Add Attendance" : "Edit Attendance"}
        </DialogTitle>

        <DialogContent>
          <DialogContentText>Please enter the required information.</DialogContentText>
          <TextFieldElement
            control={control}
            margin="dense"
            name="issueSummary"
            label="Issue"
            type="text"
            fullWidth
            variant="standard"
            disabled
          />
          <TextFieldElement
            control={control}
            margin="dense"
            name="employeeName"
            label="Employee Name"
            type="text"
            fullWidth
            variant="standard"
            disabled
          />
          <DateTimePickerElement
            control={control}
            name="worklogStarted"
            label="Record Time"
            type="text"
            inputProps={{ margin: "dense", variant: "standard", fullWidth: true }}
            required
          />
          <TextFieldElement
            control={control}
            margin="dense"
            name="timeSpentSeconds"
            label="Time Spent in Seconds"
            type="number"
            fullWidth
            variant="standard"
          />
        </DialogContent>

        {/* </MDBox> */}

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Submit</Button>
        </DialogActions>
      </FormContainer>
    </Dialog>
  );
}

// Setting default values for the props of DataTable
AddDialog.defaultProps = {
  open: false,
  userId: null,
  defaultValues: {},
  onClose: null,
  onSubmit: null,
};

// Typechecking props for the DataTable
AddDialog.propTypes = {
  open: PropTypes.bool,
  type: PropTypes.oneOf(["add", "edit"]).isRequired,
  userId: PropTypes.string,
  defaultValues: PropTypes.object,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddDialog;
